import { render, staticRenderFns } from "./blogsPage.vue?vue&type=template&id=dc0106bc&scoped=true"
import script from "./blogsPage.vue?vue&type=script&lang=js"
export * from "./blogsPage.vue?vue&type=script&lang=js"
import style0 from "./blogsPage.vue?vue&type=style&index=0&id=dc0106bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0106bc",
  null
  
)

export default component.exports